<template>
  <div class="CouponListPage">
    <NavTabs
      :items="navList.list"
      :active-index="navList.nowSelectedNo"
      @change="changeNav"
    />
    <div class="couponList">
      <!-- 列表 -->
      <div class="list">
        <van-pull-refresh
          v-model="refreshing"
          @refresh="onRefresh"
          class="van-pull-refresh"
        >
          <van-list
            v-model="loading"
            :finished="finished"
            @load="onLoad"
            v-if="couponList.length > 0"
            offset="300"
            class="couponList__vanList"
          >
            <div class="itemBox" v-for="(value, key) in couponList" :key="key">
              <CouponItem
                :coupon="value"
                :status="status"
                :show-action-button="shouldShowUseButton(value)"
                action-button-text="去使用"
                @use-coupon="buttonOnClick(value.kind)"
              />
            </div>
          </van-list>
          <!-- 没有数据 -->
          <div class="noData" v-else-if="!loading && !refreshing">
            <img src="../../assets/icon_no_coupon.png" alt="" />
            <p>无优惠券</p>
          </div>
        </van-pull-refresh>
      </div>
      <!-- 可拖动按钮组件 -->
      <SlidingButtons @toHistory="toHistory(kind)"/>
    </div>

    <!-- loading组件 -->
    <transition name="fade">
      <loading v-show="loading"></loading>
    </transition>
  </div>
</template>

<script>
import { kindCount, personalCoupon } from "@/api/HttpService";
import CouponItem from "@/components/CouponItem/CouponItem.vue";
import NavTabs from "@/components/NavTabs/NavTabs.vue";
import Loading from "@/components/loading/loading.vue";
import SlidingButtons from "@/components/slidingButtons/slidingButtons.vue";

export default {
  name: "CouponListPage",
  mounted: function () {
    document.title = "优惠券";
    // 根据对应的客户端构建导航栏数据（客户端之间有区别），默认为全部
    this.navConfig = this.buildNavConfig();
    this.navList.list = this.navConfig.map(({ label }) => `${label} 0`);
    // 获取优惠券数量
    this.getKindCount();
    // tab的位置
    let initialIndex = 0;
    // 当存在业务参数时 根据传参，跳转对应tab的列表
    if (this.$route.query.type) {
      // 获取对应tab的索引
      const targetIndex = this.getNavIndexByType(this.$route.query.type);
      if (targetIndex !== -1) {
        initialIndex = targetIndex;
      }
    }
    this.navList.nowSelectedNo = initialIndex;
    // 获取对应的优惠券类型
    this.kind =
      this.navConfig[this.navList.nowSelectedNo]?.kind ||
      this.navConfig[0]?.kind ||
      10;
    // 切换到对应的tab
    this.changeNav(this.navList.nowSelectedNo);
  },
  components: {
    SlidingButtons,
    Loading,
    CouponItem,
    NavTabs,
  },
  data: function () {
    return {
      // 分渠道展示tabs
      navConfig: [],
      // tab数据
      navList: {
        nowSelectedNo: 0,
        list: [],
      },
      loading: false,
      // 优惠券列表
      couponList: [],
      refreshing: false,
      finished: false,
      pageNum: 1,
      pageSize: 10,
      // 优惠券类型
      kind: 10,
      status: 1,
    };
  },
  computed: {
    isFromApp() {
      return this.$store?.state?.source === 'app';
    }
  },
  methods: {
    // 点击顶部nav
    changeNav: async function (key) {
      // 获取对应的kind
      const targetTab = this.navConfig[key] || this.navConfig[0];
      if (targetTab) {
        this.kind = targetTab.kind;
      }
      this.loading = true;
      this.navList.nowSelectedNo = key;
      this.couponList = [];
      this.pageNum = 1;
      this.finished = false;
      await this.personalCoupon();
    },
    // 获取优惠券列表数据
    personalCoupon: async function () {
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        kind: this.kind,
        status: 1,
        classes: 10,
      };
      await personalCoupon(params)
        .then(({ res }) => {
          // 如果没有下一页了
          if(res.originalData.code == "SUCCESS" && res.originalData.bizCode == "SUCCESS"){
            if (res.data.pageNum >= res.data.pages) {
              console.log("是否还有下一页");
              this.finished = true;
            } else {
              this.finished = false;
            }
            this.couponList.push(...res.data.data);
            this.pageNum++;
          }else{
            this.$toast(res.originalData.bizMsg || "网络异常")
            this.finished = true;
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast("网络异常");
          this.finished = true;
        });
      this.loading = false;
    },
    // 获取优惠券数量，用于tab显示
    getKindCount: async function () {
      try {
        const { res } = await kindCount({});
        console.log(JSON.stringify(res.data));
        const formatCount = (count = 0) => (count > 99 ? "99+" : count);
        const countByKind = res.data.reduce((acc, item) => {
          acc[item.kind] = item.count;
          return acc;
        }, {});
        this.navList.list = this.navConfig.map(
          ({ kind, label }) => `${label} ${formatCount(countByKind[kind])}`
        );
      } catch (err) {
        console.log(err);
        // this.$toast("网络异常");
      }
    },
    // 加载下一页
    onLoad: async function () {
      console.log("加载下一页");
      this.loading = true;
      await this.personalCoupon();
    },
    // list刷新
    onRefresh: async function () {
      console.log("开始刷新");
      this.couponList = [];
      this.pageNum = 1;
      this.finished = false;
      this.loading = false;
      this.refreshing = true;
      await this.personalCoupon();
      this.refreshing = false;
    },
    // 跳转历史优惠券
    toHistory: function (kind) {
      this.saveTabType();
      this.$router.push({
        name: "HistoryListPage",
        query: {
          kind: kind,
        },
      });
    },
    // 右侧button的点击事件
    buttonOnClick: function (kind) {
      this.saveTabType();
      switch (kind) {
        case 20: //定制公交订单
          window.location.href = "liangla://main/custom_bus";
          break;
        case 30: //国联行
          window.location.href = process.env.VUE_APP_GLX_URL;
          break;
        case 40: //悦行
          window.location.href = process.env.VUE_APP_TAXI_URL;
          break;
        case 50: //权益中心
          window.location.href = process.env.VUE_APP_BENEFITS_URL;
          break;
        case 80: //话费充值
          window.location.href = process.env.VUE_APP_RECHARGE_URL;
          break;
      }
    },
    // 是否展示使用按钮
    shouldShowUseButton: function (coupon) {
      if (!coupon) {
        return false;
      }
      return [20, 30, 40, 50, 80].includes(coupon.kind);
    },
    saveTabType(){
      let type = this.navConfig[this.navList.nowSelectedNo].type;
      this.$router.replace({
        name: "CouponListPage",
        query: {
          type: type
        },
      });
    },
    // 构建导航栏
    buildNavConfig() {
      const appNav = [
        { kind: 10, label: "公交券", type: "bus" },
        { kind: 30, label: "汽车票券", type: "glx" },
        { kind: 20, label: "定制巴士券", type: "customBus" },
        { kind: 40, label: "打车券", type: "taxi" },
        { kind: -1, label: "其他", type: "other" },
      ];
      const wxNav = [
        { kind: 10, label: "公交券", type: "bus" },
        { kind: 30, label: "汽车票券", type: "glx" },
        { kind: -1, label: "其他", type: "other" },
      ];
      return this.isFromApp ? appNav : wxNav;
    },
    // 获取导航栏tab对应的type
    getNavIndexByType(type) {
      if (!type || !this.navConfig.length) {
        return -1;
      }
      return this.navConfig.findIndex((item) => item.type === type);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../page/CouponListPage/CouponListPage.scss";
</style>
